// tslint:disable-next-line:no-any
export function applyMixins(derivedClass, baseClass) {
    // tslint:disable:typedef
    baseClass.forEach(function (baseClass) {
        Object.getOwnPropertyNames(baseClass.prototype).forEach(function (name) {
            derivedClass.prototype[name] = baseClass.prototype[name];
        });
    });
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-react-base/src/util.js
// module id = 1825
// module chunks = 0